import loadAnimation from "../media/catLoader.json";
import Lottie from "lottie-web";
import { motion } from "motion/react";
import { useNavigate } from "react-router-dom";
import { BouncyArc } from "ldrs/react";
import "ldrs/react/BouncyArc.css";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import Aos from "aos";
import Swal from "sweetalert2";

import useFirebaseStore from "../store/firebasestore";

function ConfirmPayment() {
    const navigate = useNavigate();
    const loadContAnim = useRef(null);

    const userName = useFirebaseStore((s) => s.userName);
    const userID = useFirebaseStore((s) => s.userID);

    const destination = localStorage.getItem("destination") || "";
    const delText = localStorage.getItem("delText") || "";
    const phone = localStorage.getItem("phone") || "";

    const checkoutName =
        localStorage.getItem("checkoutName") || "";

    const checkoutEmail =
        localStorage.getItem("checkoutEmail") || "";

    const checkoutUid =
        localStorage.getItem("checkoutUid") || "guest";

    const checkoutCart = JSON.parse(
        localStorage.getItem("checkoutCartItems") || "[]"
    );

    const [confirmPayLoader, setConfirmPayLoader] = useState(false);

    const params = new URLSearchParams(window.location.search);

    const trxref = params.get("trxref");
    const reference = params.get("reference");

    const transactionReference =
        trxref || reference;

    useEffect(() => {
        if (transactionReference) {
            checkPayment();
        }
    }, []);

    useEffect(() => {
        Aos.init({
            duration: 1000
        });

        const animation = Lottie.loadAnimation({
            container: loadContAnim.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: loadAnimation
        });

        return () => animation.destroy();
    }, []);

    function formatDate(dateInput = new Date()) {
        const date = new Date(dateInput);

        const day = date.getDate();

        const suffix = (d) => {
            if (d > 3 && d < 21) {
                return "th";
            }

            switch (d % 10) {
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        };

        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];

        const month = months[date.getMonth()];
        const year = String(date.getFullYear()).slice(-2);

        return `${day}${suffix(day)} ${month} '${year}`;
    }

    const saveReceiptData = (amount) => {
        const receiptName =
            checkoutName ||
            userName ||
            "Customer";

        const receiptDestination =
            destination || "";

        const receiptPhone =
            phone || "";

        const receiptEmail =
            checkoutEmail || "";

        localStorage.setItem(
            "receiptName",
            receiptName
        );

        localStorage.setItem(
            "receiptDestination",
            receiptDestination
        );

        localStorage.setItem(
            "receiptPhone",
            receiptPhone
        );

        localStorage.setItem(
            "receiptEmail",
            receiptEmail
        );

        localStorage.setItem(
            "receiptAmount",
            String(amount)
        );

        localStorage.setItem(
            "receiptTransaction",
            transactionReference || ""
        );
    };

    const clearCheckoutData = () => {
        localStorage.removeItem("destination");
        localStorage.removeItem("phone");
        localStorage.removeItem("delText");
        localStorage.removeItem("checkoutName");
        localStorage.removeItem("checkoutEmail");
        localStorage.removeItem("checkoutUid");
        localStorage.removeItem("checkoutCartItems");
        localStorage.removeItem("guestCartItems");
    };

    const goToReceipt = (amount) => {
        saveReceiptData(amount);

        clearCheckoutData();

        navigate(
            "/receipt?" +
                `trxref=${transactionReference}`
        );
    };

    const sendConfirmationSMS = async () => {
        try {
            const customerName =
                checkoutName ||
                userName ||
                "Customer";

            const clientSms = await axios.post(
                "https://schoollabelbackend-iwy4.onrender.com/sendSMStoClient",
                {
                    fon: phone,
                    name: customerName
                }
            );

            console.log(
                "Client SMS sent:",
                clientSms.data
            );

            const adminSms = await axios.post(
                "https://schoollabelbackend-iwy4.onrender.com/sendSMStoAdmin",
                {
                    CustomerName: customerName
                }
            );

            console.log(
                "Admin SMS sent:",
                adminSms.data
            );

            return true;
        } catch (error) {
            console.error(
                "SMS sending failed:",
                error
            );

            return false;
        }
    };

    const checkPayment = async () => {
        if (confirmPayLoader) {
            return;
        }

        if (!transactionReference) {
            Swal.fire(
                "Payment Reference Missing",
                "We could not find your Paystack transaction reference.",
                "error"
            );

            return;
        }

        try {
            setConfirmPayLoader(true);

            const finalUserId =
                checkoutUid ||
                userID ||
                "guest";

            const finalName =
                checkoutName ||
                userName ||
                "Guest User";

            const finalEmail =
                checkoutEmail || "";

            console.log(
                "Checking payment:",
                transactionReference
            );

            console.log(
                "Customer:",
                finalName
            );

            console.log(
                "User ID:",
                finalUserId
            );

            console.log(
                "Cart items:",
                checkoutCart
            );

            const resp = await axios.post(
                "https://schoollabelbackend-iwy4.onrender.com/trxnStatus",
                {
                    name: finalName,
                    userId: finalUserId,
                    guestEmail: finalEmail,
                    cartItems: checkoutCart,
                    refCode: transactionReference,
                    destination,
                    delText,
                    phone,
                    date: formatDate()
                }
            );

            const result = resp.data;

            console.log(
                "Transaction verification result:",
                result
            );

            if (
                result.status === true &&
                result.message ===
                    "Verification successful"
            ) {
                const amount =
                    result.data?.amount || 0;

                saveReceiptData(amount);

                const smsSent =
                    await sendConfirmationSMS();

                if (!smsSent) {
                    Swal.fire(
                        "Payment Successful",
                        "Your payment was received, but we couldn't send the confirmation SMS.",
                        "warning"
                    );
                }

                clearCheckoutData();

                navigate(
                    "/receipt?" +
                        `trxref=${transactionReference}`
                );

                return;
            }

            if (
                result.status === true &&
                result.message ===
                    "already_processed"
            ) {
                const amount =
                    result.data?.amount || 0;

                saveReceiptData(amount);

                Swal.fire(
                    "Payment Confirmed",
                    "Your payment has already been processed. Redirecting to your receipt.",
                    "success"
                );

                clearCheckoutData();

                navigate(
                    "/receipt?" +
                        `trxref=${transactionReference}`
                );

                return;
            }

            Swal.fire(
                "Payment Failed",
                "We have not received your payment yet. Please try again.",
                "error"
            );

            setConfirmPayLoader(false);

        } catch (error) {
            console.error(
                "Payment verification error:",
                error
            );

            setConfirmPayLoader(false);

            Swal.fire(
                "Verification Error",
                "We could not verify your payment. Please try again.",
                "error"
            );
        }
    };

    return (
        <div className="confirmPaymentWrap">

            <div
                className="catLoader"
                ref={loadContAnim}
            ></div>

            <div className="catLoaderInfo">

                <p>
                    Please verify once you have
                    completed the payment.
                </p>

                <div className="confirmPaymentWrapBtn">

                    {confirmPayLoader ? (
                        <BouncyArc
                            size="60"
                            speed="1"
                            color="#25A9E1"
                        />
                    ) : (
                        <motion.button
                            whileHover={{
                                scale: 1.05
                            }}
                            whileTap={{
                                scale: 0.8
                            }}
                            onClick={checkPayment}
                        >
                            Verify Payment
                        </motion.button>
                    )}

                </div>

            </div>

        </div>
    );
}

export default ConfirmPayment;